module.exports = __webpack_public_path__ + "img/transferencia_de_modalidade.542eeb54.svg";